export default __webpack_public_path__ + "static/media/ico_back.93481225.svg";